/*
    Alert.js - Alert model
 */

import {Rest} from '@/paks/vu-app'

export default new Rest('Alert', {
    invoke: {method: 'POST', uri: '/:controller/invoke'},
})
